import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutUs } from './pages/AboutUs';
import { Location } from './pages/Location';
import { Menu } from './pages/Menu';
import { Catering } from './pages/Catering';
import { Events } from './pages/Events';

/*
 * ─────────────────────────────────────────────────────────────────────────
 * ARCHIVED ROUTE: /memory-care-together
 *
 * The Memory Care Together campaign page is intentionally OFFLINE. The page
 * itself is fully preserved at pages/MemoryCareTogether.tsx — nothing was
 * deleted — so it can be brought back for next year's anniversary.
 *
 * TO RESTORE IT:
 *   1. Uncomment the import below and the <Route> inside <Routes>.
 *   2. Re-add the nav entry in components/HamburgerMenu.tsx (look for the
 *      "ARCHIVED" comment at the end of the menuItems array):
 *        { name: 'Memory Care Together', href: '/memory-care-together',
 *          icon: HandHeart }
 *      HandHeart must be re-added to that file's lucide-react import.
 *   3. Re-add the homepage teaser section in pages/LandingPage.tsx (look for
 *      the "ARCHIVED" comment between the Grounded Mornings and Visit Us
 *      sections). It also needs HandHeart back in its lucide-react import.
 *   4. Re-add the sitemap entry in public/sitemap.xml:
 *        <url>
 *          <loc>https://www.groundedlivermore.com/memory-care-together</loc>
 *          <lastmod>YYYY-MM-DD</lastmod>
 *          <changefreq>weekly</changefreq>
 *          <priority>0.8</priority>
 *        </url>
 *   5. Refresh the page copy for the new year — dates, event details, and
 *      the recap/upcoming framing in the intro and event cards.
 * ─────────────────────────────────────────────────────────────────────────
 */
// import { MemoryCareTogether } from './pages/MemoryCareTogether';

export function App() {
  return <Router data-id="element-0" data-mp="stc7017n2umb">
      <Routes data-id="element-1" data-mp="sssqmoxn0eae">
        <Route path="/" element={<LandingPage data-id="element-3" data-mp="3686tkdjumw2" />} data-id="element-2" data-mp="swq8z8ce51t8" />
        <Route path="/about" element={<AboutUs data-id="element-5" data-mp="34nb3rfi0xwm" />} data-id="element-4" data-mp="35glr3hkw7k1" />
        <Route path="/location" element={<Location data-id="element-7" data-mp="3udazyhcy738x" />} data-id="element-6" data-mp="38b66v0ldsdg" />
        <Route path="/menu" element={<Menu data-id="element-9" data-mp="3uevsk1fpcc45" />} data-id="element-8" data-mp="3ubzumd3utnfp" />
        <Route path="/catering" element={<Catering data-id="element-11" data-mp="d4xq9hl3gfef" />} data-id="element-10" data-mp="d4nvzht0nm2x" />
        <Route path="/events" element={<Events data-id="element-13" data-mp="d2bjhk6123x9" />} data-id="element-12" data-mp="d45t42bum9m1" />
        {/* ARCHIVED — see the note above to bring this back:
         <Route path="/memory-care-together" element={<MemoryCareTogether />} />
         */}
      </Routes>
    </Router>;
}